/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.OrderBy = (function () {

    function OrderBy (form, uuid) {

        this.fieldOrder = {};

        this.setValue = function (value) {
            this.value = value;
            this.fieldOrder.field.setSelectedField(value.entityField);
            this.fieldOrder.orderType.setValue(value.orderType);
            this.fieldOrder.id = value.id;
        };

        this.getValue = function () {
            return this.fieldOrder;
        }.bind(this);

        var getFieldDomain = function (description, value) {
            return { description: description, value: value };
        };

        var getOrderByLine = function () {
            var container = document.createElement('div');
            var fieldDomains = [];
            var orderField = new Monet.UI.Fields.PickList();
            var selectFieldList = new Greenmile.PanelBuilder.SelectFieldList("RouteView");

            container.className = 'addNewOrderByAttribute';

            orderField.setId('panelbuilder_order');
            orderField.setDefaultValue('ASC');
            orderField.setTextLabel('');
            orderField.setInputName('order');
            orderField.setMandatory(true);

            fieldDomains.push(getFieldDomain('general.orderBy.Asc', 'ASC'));
            fieldDomains.push(getFieldDomain('general.orderBy.Desc', 'DESC'));

            orderField.setFieldDomains(fieldDomains);

            this.fieldOrder = {
                field: selectFieldList,
                orderType: orderField
            };

            var callbackDelete = function (e) {
                var orderContainer = e.target.parentNode;
                orderContainer.parentNode.removeChild(orderContainer);

                delete form.orders[uuid];

            }.bind(this);

            container.appendChild(selectFieldList.render());
            container.appendChild(orderField.render());

            orderField.input.removeChild(orderField.input[0]);

            container.appendChild(Greenmile.PanelBuilder.Utils.getBtnDelete(callbackDelete));

            return container;

        }.bind(this);

        this.render = function () {

            var fragment = document.createDocumentFragment();
            fragment.appendChild(getOrderByLine());

            return fragment;
        };

    }

    return OrderBy;

}());